import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { AuthProvider } from "./context/AuthContext";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProductsPage from "./pages/ProductsPage";
import TechnologiesPage from "./pages/TechnologiesPage";
import CareersPage from "./pages/CareersPage";
import { BlogsListPage, BlogDetailPage } from "./pages/BlogsPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ContactPage from "./pages/ContactPage";
import DemoRequestPage from "./pages/DemoRequestPage";
import { AdminLoginPage, AdminDashboardPage } from "./pages/AdminPage";

function SiteShell({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-slate-950">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route path="/" element={<SiteShell><HomePage /></SiteShell>} />
          <Route path="/about" element={<SiteShell><AboutPage /></SiteShell>} />
          <Route path="/products" element={<SiteShell><ProductsPage /></SiteShell>} />
          <Route path="/technologies" element={<SiteShell><TechnologiesPage /></SiteShell>} />
          <Route path="/careers" element={<SiteShell><CareersPage /></SiteShell>} />
          <Route path="/blogs" element={<SiteShell><BlogsListPage /></SiteShell>} />
          <Route path="/blogs/:slug" element={<SiteShell><BlogDetailPage /></SiteShell>} />
          <Route path="/testimonials" element={<SiteShell><TestimonialsPage /></SiteShell>} />
          <Route path="/contact" element={<SiteShell><ContactPage /></SiteShell>} />
          <Route path="/demo" element={<SiteShell><DemoRequestPage /></SiteShell>} />
          <Route path="/admin/login" element={<SiteShell><AdminLoginPage /></SiteShell>} />
          <Route path="/admin" element={<SiteShell><AdminDashboardPage /></SiteShell>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
